document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('header');

    // function scrollToTarget(target) {
    //     if (!target) return;
    //
    //     const headerHeight = header ? header.offsetHeight + 50 : 0;
    //     const elementPosition = target.getBoundingClientRect().top;
    //     const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
    //
    //     window.scrollTo({
    //         top: offsetPosition,
    //         behavior: 'smooth'
    //     });
    // }

    function scrollToTarget(target) {
        if (!target) return;

        const headerHeight = header ? header.offsetHeight + 50 : 0;

        const elementRect = target.getBoundingClientRect();
        const elementTop = elementRect.top + window.pageYOffset;
        const elementHeight = elementRect.height;
        const viewportHeight = window.innerHeight;

        const offsetPosition =
            elementTop
            - (viewportHeight / 2)
            + (elementHeight / 2)
            // - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
        link.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#' || targetId.trim() === '') return;

            const target = document.querySelector(targetId);
            if (!target) return;

            e.preventDefault();
            scrollToTarget(target);
        });
    });

    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);

        if (target) {
            setTimeout(() => scrollToTarget(target), 50);
        }
    }
});